<template>
	<div>
		<el-card class="box-card">
			<div style="padding:-20px">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/home/index' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>系统管理</el-breadcrumb-item>
					<el-breadcrumb-item>部门管理</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
		</el-card>
		
		<el-card class="box-card mainPadding" >
			<el-form :inline="true" :model="form" class="demo-form-inline" size="small">
				<el-form-item label="部门名称">
					<el-input v-model="form.role" placeholder="部门名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getData()" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="add()" icon="el-icon-plus">添加</el-button>
				</el-form-item>
			</el-form>
			<el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column type="index" label="#">
				</el-table-column>
				<el-table-column prop="department" label="部门名称">
				</el-table-column>
				<el-table-column prop="belong" label="所属部门" :formatter="getBelong">
				</el-table-column>
				<el-table-column prop="depManager" label="部门经理">
				</el-table-column>
				<el-table-column prop="phone" label="联系电话">
				</el-table-column>
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#dcdfe6" disabled>
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="primary" icon="el-icon-edit" size="small" @click="edit(scope.$index,scope.row)"></el-button>
						<el-button type="danger" icon="el-icon-delete" size="small" @click="del(scope.$index,scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[10, 20, 30, 50]" :page-size="100" layout="total, prev, pager, next, jumper" :total="10">
			</el-pagination>
		</el-card>

		<!--添加弹窗-->
		<el-dialog :title="title" :visible.sync="dialogAddFormVisible" width="35%">
			<el-form :model="addForm" size="small" label-width="80px" :rules="rules">
				<el-form-item label="所属部门" prop="belong">
					<el-select placeholder="请选择" v-model="addForm.belong" autocomplete="off">
						<el-option v-for="(item,index) in belongList" :key="item.index" :label="item.name" :value="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="部门名称" prop="department">
					<el-input v-model="addForm.department" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="部门经理" prop="depManager">
					<el-input v-model="addForm.depManager" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="phone">
					<el-input v-model="addForm.phone" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="状态" prop="status">
					<el-switch v-model="addForm.status" active-color="#13ce66" inactive-color="#dcdfe6">
					</el-switch>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogAddFormVisible = false" size="small">取 消</el-button>
				<el-button type="primary" @click="dialogAddFormVisible = false" size="small">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//表格
				tableData: [{
						id: 1,
						department: '部门一部',
						depManager: '郭麒麟',
						cjDate: '2020-04-04',
						status: true,
						phone: '1563269865',
						belong: '1',
						children: [{
							id: 11,
							department: '考勤部',
							depManager: '李天宇',
							cjDate: '2020-04-04',
							status: true,
							phone: '1563269865',
							belong: '2',

						}, {
							id: 12,
							department: '生活部',
							depManager: '周梦安',
							cjDate: '2020-04-04',
							status: true,
							phone: '1563269865',
							belong: '2',

						}]

					},
					{
						id: 2,
						department: '部门二部',
						depManager: '郭麒麟',
						cjDate: '2020-04-04',
						status: true,
						phone: '1563269865',
						belong: '1',
						children: [{
							id: 21,
							department: '考勤部',
							depManager: '张天萌',
							cjDate: '2020-04-04',
							status: true,
							phone: '1563269865',
							belong: '3',
						}, {
							id: 22,
							department: '生活部',
							depManager: '李亚辉',
							cjDate: '2020-04-04',
							status: true,
							phone: '1563269865',
							belong: '3',
						}]

					}
				],
				//部门
				belongList: [{
						name: '目录'
					}, {
						name: '部门一部'
					},
					{
						name: '部门二部'
					}
				],
				//查询表单
				form: {
					department: '',
					depManager: '',
					phone: '',
					status: ''
				},
				//添加表单
				addForm: {
					role: '',
					roleN: ''
				},
				//权限弹窗
				dialogAddFormVisible: false,
				dialogqxFormVisible: false,
				rules: {
					roleN: [{
						required: true,
						message: '请输入角色代码',
						trigger: 'blur'
					}],
					role: [{
						required: true,
						message: '请输入角色',
						trigger: 'blur'
					}],
				},
				title: '',
				currentPage4: 4
			}
		},
		created() {},
		methods: {
			//获取表格数据
			getData() {
				alert('getData')

			},
			//删除
			del(index, row) {
				console.log(row);
				this.$confirm('是否删除部门为:' + row.department + '的数据！', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//编辑
			edit(index, row) {
				console.log(row.belong);
				this.title = "编辑";
				this.dialogAddFormVisible = true;
				this.addForm.belong = row.belong;
				this.addForm.department = row.department;
				this.addForm.depManager = row.depManager;
				this.addForm.phone = row.phone;
				this.status = row.status;
			},
			//权限
			jur() {
				this.dialogqxFormVisible = true
			},
			//添加
			add() {
				this.title = "添加";
				this.addForm.department = '';
				this.addForm.depManager = '';
				this.addForm.phone = '';
				this.status = false;
				this.dialogAddFormVisible = true

			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			//转换所属部门
			getBelong(row, column) {
				return row.belong == 1 ? '目录' : row.belong == 2 ? '部门一部' : row.belong == 3 ? '部门二部' : '';
			}

		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/system/department.vue